module.exports = "https://static.wagwalking.com/_next/static/images/dog-sitting-1-7db94234b523f5cb1579fda4ae489eed.svg";